// Generated from the normalboard.txt and stickycore.txt examples supplied for the tutorial.
// Tutorial-only data: no live account calls are made from these arrays.
export const NORMAL_BOARD_TILES = [
  {
    "id": 894,
    "board_id": 27,
    "label": "Ida",
    "color": "#eeeeee",
    "image_url": "https://jmew.xyz/aac/api/uploads/1/i.png",
    "position": 0,
    "created_at": "2025-05-17 05:23:35",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 932,
    "board_id": 27,
    "label": "Want",
    "color": "#eeeeee",
    "image_url": "https://jmew.xyz/aac/api/uploads/1/i-want.png",
    "position": 1,
    "created_at": "2025-05-17 05:23:35",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 898,
    "board_id": 27,
    "label": "Help",
    "color": "#eeeeee",
    "image_url": "https://jmew.xyz/aac/api/uploads/1/help.png",
    "position": 2,
    "created_at": "2025-05-17 05:23:35",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 897,
    "board_id": 27,
    "label": "Dressed",
    "color": "#eeeeee",
    "image_url": "https://static.arasaac.org/pictograms/32135/32135_300.png",
    "position": 3,
    "created_at": "2025-05-17 05:23:35",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 910,
    "board_id": 27,
    "label": "Bath",
    "color": "#eeeeee",
    "image_url": "https://static.arasaac.org/pictograms/2272/2272_300.png",
    "position": 4,
    "created_at": "2025-05-17 05:23:35",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 899,
    "board_id": 27,
    "label": "Breakfast",
    "color": "#eeeeee",
    "image_url": "https://jmew.xyz/aac/api/uploads/1/breakfast.png",
    "position": 5,
    "created_at": "2025-05-17 05:23:35",
    "is_folder": 1,
    "linked_board_id": 28,
    "folder_silent": 0
  },
  {
    "id": 911,
    "board_id": 27,
    "label": "Outside",
    "color": "#eeeeee",
    "image_url": "https://jmew.xyz/aac/api/uploads/1/outside.png",
    "position": 6,
    "created_at": "2025-05-17 05:23:35",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 924,
    "board_id": 27,
    "label": "Kind hands",
    "color": "#eeeeee",
    "image_url": "https://static.arasaac.org/pictograms/37312/37312_300.png",
    "position": 7,
    "created_at": "2025-05-17 05:23:35",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 895,
    "board_id": 27,
    "label": "You",
    "color": "#eeeeee",
    "image_url": "https://jmew.xyz/aac/api/uploads/1/you.png",
    "position": 8,
    "created_at": "2025-05-17 05:23:35",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 901,
    "board_id": 27,
    "label": "More",
    "color": "#eeeeee",
    "image_url": "https://jmew.xyz/aac/api/uploads/1/more.png",
    "position": 9,
    "created_at": "2025-05-17 05:23:35",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 931,
    "board_id": 27,
    "label": "Sorry",
    "color": "#eeeeee",
    "image_url": "https://static.arasaac.org/pictograms/38360/38360_300.png",
    "position": 10,
    "created_at": "2025-05-17 05:23:35",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 902,
    "board_id": 27,
    "label": "Toilet",
    "color": "#eeeeee",
    "image_url": "https://jmew.xyz/aac/api/uploads/1/toilet.png",
    "position": 11,
    "created_at": "2025-05-17 05:23:35",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 927,
    "board_id": 27,
    "label": "Animals",
    "color": "#eeeeee",
    "image_url": "https://static.arasaac.org/pictograms/6901/6901_300.png",
    "position": 12,
    "created_at": "2025-05-17 05:23:35",
    "is_folder": 1,
    "linked_board_id": 639,
    "folder_silent": 0
  },
  {
    "id": 905,
    "board_id": 27,
    "label": "Dinner",
    "color": "#eeeeee",
    "image_url": "https://jmew.xyz/aac/api/uploads/1/dinner.png",
    "position": 13,
    "created_at": "2025-05-17 05:23:35",
    "is_folder": 1,
    "linked_board_id": 40,
    "folder_silent": 0
  },
  {
    "id": 904,
    "board_id": 27,
    "label": "Inside",
    "color": "#eeeeee",
    "image_url": "https://jmew.xyz/aac/api/uploads/1/inside.png",
    "position": 14,
    "created_at": "2025-05-17 05:23:35",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 900,
    "board_id": 27,
    "label": "Tired",
    "color": "#eeeeee",
    "image_url": "https://static.arasaac.org/pictograms/28709/28709_300.png",
    "position": 15,
    "created_at": "2025-05-17 05:23:35",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 908,
    "board_id": 27,
    "label": "Mine",
    "color": "#eeeeee",
    "image_url": "https://static.arasaac.org/pictograms/12264/12264_300.png",
    "position": 16,
    "created_at": "2025-05-17 05:23:35",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 907,
    "board_id": 27,
    "label": "Finished",
    "color": "#eeeeee",
    "image_url": "https://jmew.xyz/aac/api/uploads/1/finish.png",
    "position": 17,
    "created_at": "2025-05-17 05:23:35",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 923,
    "board_id": 27,
    "label": "Listen",
    "color": "#eeeeee",
    "image_url": "https://jmew.xyz/aac/api/uploads/1/listen.png",
    "position": 18,
    "created_at": "2025-05-17 05:23:35",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 909,
    "board_id": 27,
    "label": "Brush teeth",
    "color": "#eeeeee",
    "image_url": "https://static.arasaac.org/pictograms/2694/2694_300.png",
    "position": 19,
    "created_at": "2025-05-17 05:23:35",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 916,
    "board_id": 27,
    "label": "Glasses",
    "color": "#eeeeee",
    "image_url": "https://static.arasaac.org/pictograms/3329/3329_300.png",
    "position": 20,
    "created_at": "2025-05-17 05:23:35",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 921,
    "board_id": 27,
    "label": "Snack",
    "color": "#eeeeee",
    "image_url": "https://jmew.xyz/aac/api/uploads/1/snack.png",
    "position": 21,
    "created_at": "2025-05-17 05:23:35",
    "is_folder": 1,
    "linked_board_id": 39,
    "folder_silent": 0
  },
  {
    "id": 920,
    "board_id": 27,
    "label": "School",
    "color": "#eeeeee",
    "image_url": "https://static.arasaac.org/pictograms/3082/3082_300.png",
    "position": 22,
    "created_at": "2025-05-17 05:23:35",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 906,
    "board_id": 27,
    "label": "Happy",
    "color": "#eeeeee",
    "image_url": "https://static.arasaac.org/pictograms/28647/28647_300.png",
    "position": 23,
    "created_at": "2025-05-17 05:23:35",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 929,
    "board_id": 27,
    "label": "Go to",
    "color": "#eeeeee",
    "image_url": "https://jmew.xyz/aac/api/uploads/1/go.png",
    "position": 24,
    "created_at": "2025-05-17 05:23:35",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 914,
    "board_id": 27,
    "label": "Wait",
    "color": "#eeeeee",
    "image_url": "https://jmew.xyz/aac/api/uploads/1/wait.png",
    "position": 25,
    "created_at": "2025-05-17 05:23:35",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 928,
    "board_id": 27,
    "label": "Look",
    "color": "#eeeeee",
    "image_url": "https://jmew.xyz/aac/api/uploads/1/look.png",
    "position": 26,
    "created_at": "2025-05-17 05:23:35",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 918,
    "board_id": 27,
    "label": "Brush hair",
    "color": "#eeeeee",
    "image_url": "https://static.arasaac.org/pictograms/21529/21529_300.png",
    "position": 27,
    "created_at": "2025-05-17 05:23:35",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 912,
    "board_id": 27,
    "label": "Drink",
    "color": "#eeeeee",
    "image_url": "https://jmew.xyz/aac/api/uploads/1/drink.png",
    "position": 28,
    "created_at": "2025-05-17 05:23:35",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 903,
    "board_id": 27,
    "label": "Play",
    "color": "#eeeeee",
    "image_url": "https://jmew.xyz/aac/api/uploads/1/play.png",
    "position": 29,
    "created_at": "2025-05-17 05:23:35",
    "is_folder": 1,
    "linked_board_id": 29,
    "folder_silent": 0
  },
  {
    "id": 922,
    "board_id": 27,
    "label": "Car",
    "color": "#eeeeee",
    "image_url": "https://static.arasaac.org/pictograms/2339/2339_300.png",
    "position": 30,
    "created_at": "2025-05-17 05:23:35",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 913,
    "board_id": 27,
    "label": "Sad",
    "color": "#eeeeee",
    "image_url": "https://static.arasaac.org/pictograms/11959/11959_300.png",
    "position": 31,
    "created_at": "2025-05-17 05:23:35",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 896,
    "board_id": 27,
    "label": "Choose",
    "color": "#eeeeee",
    "image_url": "https://jmew.xyz/aac/api/uploads/1/choose.png",
    "position": 32,
    "created_at": "2025-05-17 05:23:35",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 930,
    "board_id": 27,
    "label": "No",
    "color": "#eeeeee",
    "image_url": "https://jmew.xyz/aac/api/uploads/1/no.png",
    "position": 33,
    "created_at": "2025-05-17 05:23:35",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 919,
    "board_id": 27,
    "label": "Yes",
    "color": "#eeeeee",
    "image_url": "https://jmew.xyz/aac/api/uploads/1/yes.png",
    "position": 34,
    "created_at": "2025-05-17 05:23:35",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 915,
    "board_id": 27,
    "label": "Please",
    "color": "#eeeeee",
    "image_url": "https://static.arasaac.org/pictograms/8194/8194_300.png",
    "position": 35,
    "created_at": "2025-05-17 05:23:35",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 917,
    "board_id": 27,
    "label": "Thank you",
    "color": "#eeeeee",
    "image_url": "https://static.arasaac.org/pictograms/31206/31206_300.png",
    "position": 36,
    "created_at": "2025-05-17 05:23:35",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 925,
    "board_id": 27,
    "label": "People",
    "color": "#eeeeee",
    "image_url": "https://static.arasaac.org/pictograms/7116/7116_300.png",
    "position": 37,
    "created_at": "2025-05-17 05:23:35",
    "is_folder": 1,
    "linked_board_id": 54,
    "folder_silent": 0
  },
  {
    "id": 926,
    "board_id": 27,
    "label": "Places",
    "color": "#eeeeee",
    "image_url": "https://static.arasaac.org/pictograms/32598/32598_300.png",
    "position": 38,
    "created_at": "2025-05-17 05:23:35",
    "is_folder": 1,
    "linked_board_id": 30,
    "folder_silent": 0
  },
  {
    "id": 933,
    "board_id": 27,
    "label": "Hurt",
    "color": "#eeeeee",
    "image_url": "https://static.arasaac.org/pictograms/5484/5484_300.png",
    "position": 39,
    "created_at": "2025-05-17 05:23:35",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  }
];
export const STICKY_CORE_TILES = [
  {
    "id": 807,
    "board_id": 24,
    "label": "Somethings Wrong",
    "color": "#ffeb8a",
    "image_url": "https://static.arasaac.org/pictograms/34639/34639_300.png",
    "position": 0,
    "created_at": "2025-05-07 19:25:38",
    "is_folder": 1,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 774,
    "board_id": 24,
    "label": "I want",
    "color": "#eeeeee",
    "image_url": "https://jmew.xyz/aac/api/uploads/1/i-want.png",
    "position": 1,
    "created_at": "2025-05-07 19:25:38",
    "is_folder": 1,
    "linked_board_id": 903,
    "folder_silent": 0
  },
  {
    "id": 791,
    "board_id": 24,
    "label": "",
    "color": "#eeeeee",
    "image_url": "",
    "position": 2,
    "created_at": "2025-05-07 19:25:38",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 782,
    "board_id": 24,
    "label": "",
    "color": "#eeeeee",
    "image_url": "",
    "position": 3,
    "created_at": "2025-05-07 19:25:38",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 804,
    "board_id": 24,
    "label": "",
    "color": "#eeeeee",
    "image_url": "",
    "position": 4,
    "created_at": "2025-05-07 19:25:38",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 812,
    "board_id": 24,
    "label": "I feel",
    "color": "#eeeeee",
    "image_url": "https://static.arasaac.org/pictograms/12359/12359_300.png",
    "position": 5,
    "created_at": "2025-05-07 19:25:38",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 785,
    "board_id": 24,
    "label": "Go to",
    "color": "#eeeeee",
    "image_url": "https://jmew.xyz/aac/api/uploads/1/go.png",
    "position": 6,
    "created_at": "2025-05-07 19:25:38",
    "is_folder": 1,
    "linked_board_id": 909,
    "folder_silent": 0
  },
  {
    "id": 787,
    "board_id": 24,
    "label": "Finished",
    "color": "#eeeeee",
    "image_url": "https://jmew.xyz/aac/api/uploads/1/finish.png",
    "position": 7,
    "created_at": "2025-05-07 19:25:38",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 777,
    "board_id": 24,
    "label": "Come",
    "color": "#eeeeee",
    "image_url": "https://static.arasaac.org/pictograms/32669/32669_300.png",
    "position": 8,
    "created_at": "2025-05-07 19:25:38",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 778,
    "board_id": 24,
    "label": "Help",
    "color": "#eeeeee",
    "image_url": "https://jmew.xyz/aac/api/uploads/1/help.png",
    "position": 9,
    "created_at": "2025-05-07 19:25:38",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 802,
    "board_id": 24,
    "label": "Wait",
    "color": "#eeeeee",
    "image_url": "https://jmew.xyz/aac/api/uploads/1/wait.png",
    "position": 10,
    "created_at": "2025-05-07 19:25:38",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 780,
    "board_id": 24,
    "label": "Choose",
    "color": "#eeeeee",
    "image_url": "https://jmew.xyz/aac/api/uploads/1/choose.png",
    "position": 11,
    "created_at": "2025-05-07 19:25:38",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 779,
    "board_id": 24,
    "label": "Mine",
    "color": "#eeeeee",
    "image_url": "https://static.arasaac.org/pictograms/12264/12264_300.png",
    "position": 12,
    "created_at": "2025-05-07 19:25:38",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 775,
    "board_id": 24,
    "label": "You",
    "color": "#eeeeee",
    "image_url": "https://jmew.xyz/aac/api/uploads/1/you.png",
    "position": 13,
    "created_at": "2025-05-07 19:25:38",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 803,
    "board_id": 24,
    "label": "Listen",
    "color": "#eeeeee",
    "image_url": "https://jmew.xyz/aac/api/uploads/1/listen.png",
    "position": 14,
    "created_at": "2025-05-07 19:25:38",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 781,
    "board_id": 24,
    "label": "More",
    "color": "#eeeeee",
    "image_url": "https://jmew.xyz/aac/api/uploads/1/more.png",
    "position": 15,
    "created_at": "2025-05-07 19:25:38",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 788,
    "board_id": 24,
    "label": "Yes",
    "color": "#eeeeee",
    "image_url": "https://static.arasaac.org/pictograms/5583/5583_300.png",
    "position": 16,
    "created_at": "2025-05-07 19:25:38",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 784,
    "board_id": 24,
    "label": "No",
    "color": "#eeeeee",
    "image_url": "https://static.arasaac.org/pictograms/5525/5525_300.png",
    "position": 17,
    "created_at": "2025-05-07 19:25:38",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 811,
    "board_id": 24,
    "label": "Please",
    "color": "#eeeeee",
    "image_url": "https://static.arasaac.org/pictograms/8194/8194_300.png",
    "position": 18,
    "created_at": "2025-05-07 19:25:38",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 789,
    "board_id": 24,
    "label": "Thank you",
    "color": "#eeeeee",
    "image_url": "https://static.arasaac.org/pictograms/31206/31206_300.png",
    "position": 19,
    "created_at": "2025-05-07 19:25:38",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  }
];
export const STICKY_CONTENT_TILES = [
  {
    "id": 31811,
    "board_id": 903,
    "label": "Something to eat",
    "color": "#eeeeee",
    "image_url": "https://static.arasaac.org/pictograms/4610/4610_300.png",
    "position": 0,
    "created_at": "2026-08-20 21:46:40",
    "is_folder": 1,
    "linked_board_id": 904,
    "folder_silent": 0
  },
  {
    "id": 31815,
    "board_id": 903,
    "label": "A Drink",
    "color": "#eeeeee",
    "image_url": "https://static.arasaac.org/pictograms/29716/29716_300.png",
    "position": 1,
    "created_at": "2026-08-20 21:46:40",
    "is_folder": 1,
    "linked_board_id": 916,
    "folder_silent": 0
  },
  {
    "id": 31813,
    "board_id": 903,
    "label": "",
    "color": null,
    "image_url": null,
    "position": 2,
    "created_at": "2026-08-20 21:46:40",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 31814,
    "board_id": 903,
    "label": "",
    "color": null,
    "image_url": null,
    "position": 3,
    "created_at": "2026-08-20 21:46:40",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 31812,
    "board_id": 903,
    "label": "To Play",
    "color": "#eeeeee",
    "image_url": "https://jmew.xyz/aac/api/uploads/1/play.png",
    "position": 4,
    "created_at": "2026-08-20 21:46:40",
    "is_folder": 1,
    "linked_board_id": 912,
    "folder_silent": 0
  },
  {
    "id": 31823,
    "board_id": 903,
    "label": "",
    "color": null,
    "image_url": null,
    "position": 5,
    "created_at": "2026-08-20 21:46:40",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 31817,
    "board_id": 903,
    "label": "",
    "color": null,
    "image_url": null,
    "position": 6,
    "created_at": "2026-08-20 21:46:40",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 31818,
    "board_id": 903,
    "label": "",
    "color": null,
    "image_url": null,
    "position": 7,
    "created_at": "2026-08-20 21:46:40",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 31819,
    "board_id": 903,
    "label": "Self care",
    "color": "#eeeeee",
    "image_url": "https://static.arasaac.org/pictograms/7309/7309_300.png",
    "position": 8,
    "created_at": "2026-08-20 21:46:40",
    "is_folder": 1,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 31816,
    "board_id": 903,
    "label": "The Toilet",
    "color": "#eeeeee",
    "image_url": "https://static.arasaac.org/pictograms/2430/2430_300.png",
    "position": 9,
    "created_at": "2026-08-20 21:46:40",
    "is_folder": 1,
    "linked_board_id": 917,
    "folder_silent": 0
  },
  {
    "id": 31824,
    "board_id": 903,
    "label": "",
    "color": null,
    "image_url": null,
    "position": 10,
    "created_at": "2026-08-20 21:46:40",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 31822,
    "board_id": 903,
    "label": "",
    "color": null,
    "image_url": null,
    "position": 11,
    "created_at": "2026-08-20 21:46:40",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 31820,
    "board_id": 903,
    "label": "People",
    "color": "#eeeeee",
    "image_url": "https://static.arasaac.org/pictograms/7116/7116_300.png",
    "position": 12,
    "created_at": "2026-08-20 21:46:40",
    "is_folder": 1,
    "linked_board_id": 907,
    "folder_silent": 0
  },
  {
    "id": 31821,
    "board_id": 903,
    "label": "Places",
    "color": "#eeeeee",
    "image_url": "https://static.arasaac.org/pictograms/32598/32598_300.png",
    "position": 13,
    "created_at": "2026-08-20 21:46:40",
    "is_folder": 1,
    "linked_board_id": 909,
    "folder_silent": 0
  },
  {
    "id": 31825,
    "board_id": 903,
    "label": "",
    "color": null,
    "image_url": null,
    "position": 14,
    "created_at": "2026-08-20 21:46:40",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 31826,
    "board_id": 903,
    "label": "",
    "color": null,
    "image_url": null,
    "position": 15,
    "created_at": "2026-08-20 21:46:40",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 31827,
    "board_id": 903,
    "label": "",
    "color": null,
    "image_url": null,
    "position": 16,
    "created_at": "2026-08-20 21:46:40",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 31828,
    "board_id": 903,
    "label": "",
    "color": null,
    "image_url": null,
    "position": 17,
    "created_at": "2026-08-20 21:46:40",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 31829,
    "board_id": 903,
    "label": "",
    "color": null,
    "image_url": null,
    "position": 18,
    "created_at": "2026-08-20 21:46:40",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  },
  {
    "id": 31830,
    "board_id": 903,
    "label": "",
    "color": null,
    "image_url": null,
    "position": 19,
    "created_at": "2026-08-20 21:46:40",
    "is_folder": 0,
    "linked_board_id": null,
    "folder_silent": 0
  }
];
